<template>
  <div class="">
    <div class="container mt-5 mb-5 rounded bg-success p-2 text-center" v-if="updateExists">
      <h5 class="text-white" v-t="'update_site_message.message'"></h5>
      <span @click="refreshApp()" class="btn btn-primary" v-t="'update_site_message.update_button'"></span>
    </div>
  </div>
</template>

<script>
import UpdateSiteController from '@moeinmdn/mixitweb-front-modules/src/plugin/class/UpdateSiteController'

export default {
  name: "m-update-site-message-1",
  mixins: [UpdateSiteController],
};
</script>

<style scoped>

</style>

